import BaseStore from '../BaseStore';
import RatingEquationModel from '../../models/Hydrology/RatingEquationModel';

class RatingEquationStore extends BaseStore {

  seriesTypeOptions = [
    { label: 'Power Series', value: 1 },
    { label: 'Polynomial Series', value: 2 },
  ]

  constructor(transportLayer) {
    super(RatingEquationModel, transportLayer);
  }

  _createEquation(id, json) {
    this.findById(id).equations.push(json);
  }

  _updateEquation(id, json) {
    this._removeEquation(id, json.id);
    this._createEquation(id, json);
  }

  _removeEquation(id, eq_id) {
    this.findById(id).equations = this.findById(id).equations.filter(item => +item.id !== +eq_id)
  }

  createEquation(json) {
    let curveId = json.rating_curve_id;
    return this.transportLayer.equation.create(json)
      .then(res => {
        const id = !!res && Array.isArray(res.id) ? res.id[0] : res.id;
        this._createEquation(curveId, Object.assign({}, json, { id }));
        return res;
      })
  }

  updateEquation(payload) {
    return this.transportLayer.equation.update(payload.id, payload)
      .then(res => {
        let curveId = payload.rating_curve_id;
        this._updateEquation(curveId, payload)
        return res;
      })
  }

  removeEquation(id, eq_id) {
    return this.transportLayer.equation.remove(eq_id)
      .then(res => {
        this._removeEquation(id, eq_id);
        return res;
      })
  }

}

export default RatingEquationStore;


// WEBPACK FOOTER //
// ./src/stores/Hydrology/RatingEquationStore.js